// Pure reducer for the broker auth session. Extracted from the provider so the
// state transitions are exhaustively unit-testable (CLAUDE.md #1) with no React
// or network involved. Tokens live in memory only (CLAUDE.md #5/#9) — never
// localStorage — so a tab refresh restarts in "loading" and silently re-derives
// the session from the httpOnly refresh cookie.

import type { AuthTokens, BrokerIdentity } from "@/lib/brokerAuth";

export type AuthStatus = "loading" | "anonymous" | "authenticated";

export interface AuthState {
  status: AuthStatus;
  tokens: AuthTokens | null;
  identity: BrokerIdentity | null;
}

export type AuthAction =
  | { type: "authenticated"; tokens: AuthTokens; identity: BrokerIdentity }
  | { type: "anonymous" };

// Starts "loading": the provider attempts a silent refresh on mount before the
// UI commits to showing signed-in vs signed-out chrome.
export const initialAuthState: AuthState = {
  status: "loading",
  tokens: null,
  identity: null,
};

export function authReducer(state: AuthState, action: AuthAction): AuthState {
  switch (action.type) {
    case "authenticated":
      return {
        status: "authenticated",
        tokens: action.tokens,
        identity: action.identity,
      };
    case "anonymous":
      return { status: "anonymous", tokens: null, identity: null };
    default:
      return state;
  }
}
